import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=27db722a&scoped=true&"
import script from "./AppView.vue?vue&type=script&lang=js&"
export * from "./AppView.vue?vue&type=script&lang=js&"
import style0 from "./AppView.vue?vue&type=style&index=0&id=27db722a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db722a",
  null
  
)

export default component.exports